import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from './auth.tsx'

// refetchOnWindowFocus: true so when a user comes back to a tab after
// idle, queries refetch. Combined with the 401 interceptor in api.ts,
// this is what surfaces server-side session expiry / role revocation —
// the refetch hits 401, the interceptor flips auth state, the user
// gets bounced to /login. Without it, an idle tab can show stale UI
// until the user manually clicks something. See docs/specs/auth-and-security.md.
const qc = new QueryClient({
  defaultOptions: { queries: { staleTime: 5_000, refetchOnWindowFocus: true, retry: 1 } },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
